import React, { useRef } from 'react'
import { ResponsiveContainer, Legend, PieChart, Pie, Cell } from 'recharts'
import classNames from 'classnames'
import Card from 'components/Detail/Card'
import IncidentChartMenu from './components/IncidentChartMenu'
import { LegendItems } from './components/shapes'
import { chartGradientDefs } from '../../../../containers/CustomDashboardv2/Dashboard/details/charts/utils'
import { LabelError } from './components/labels'

const IncidentPieChart = ({ color, isLoading, title, chartData = [], chartId, chartDef, caption, height, legendPosition = 'right', outerRadius = 80, chartHeight, isAnimationActive = true, onExplain }) => {
  const chartRef = useRef(null)

  return (
    <Card
      noGrid
      menu={onExplain && 'dot'}
      color={color}
      isLoading={isLoading}
      className={classNames('viso-chart-card', isLoading && 'viso-chart-card--loading')}
      content={
        <div className='viso-chart-card__content viso-chart-card__content--doughnut' style={{ height: height }} id={chartId}>
          {title && <div className='viso-chart-card__title viso-chart-card__title--doughnut'>{title}</div>}

          <div className='viso-chart-card__container viso-chart-card__container--doughnut'>
            <div ref={chartRef} className='viso-chart-card__data viso-chart-card__data--doughnut'>
              {!isLoading && chartData.every(item => item.value === 0) ?
                <LabelError />
                :
                <ResponsiveContainer width='100%' height={chartHeight}>

                  <PieChart margin={{ top: 5, right: 30, left: 0, bottom: 5 }} height={chartHeight}>
                    {chartData?.length > 0 && chartData.map((entry, index) => {
                      const fillId = `${chartId}_${entry.name.replaceAll(' ', '')}`
                      const getFill = entry.fill
                      return (
                        <React.Fragment key={`fill-${index}`}>
                          {chartGradientDefs(fillId, getFill)}
                        </React.Fragment>
                      )
                    })}

                    <Pie
                      data={[{ fillBg: 100 }]}
                      dataKey='fillBg'
                      cx='50%'
                      cy='50%'
                      outerRadius={`${outerRadius + 6}%`}
                      isAnimationActive={isAnimationActive}
                    >
                      <Cell fill='#eee' stroke='#eee' />
                    </Pie>

                    <Pie
                      data={chartData}
                      dataKey='value'
                      cx='50%'
                      cy='50%'
                      outerRadius={`${outerRadius}%`}
                      rootTabIndex={33}
                      isAnimationActive={isAnimationActive}
                    >
                      {chartData?.length > 0 && chartData.map((entry, index) => {
                        const fillId = `${chartId}_${entry.name.replaceAll(' ', '')}`

                        return (
                          <Cell
                            key={`cell-${index}`}
                            fill={`url(#${fillId}Fill)`}
                            stroke='#eee'
                          />
                        )
                      })}
                    </Pie>

                    <Legend
                      content={<LegendItems iconType='square' legendPosition={legendPosition} metrics={chartDef.metrics} />}
                      layout={legendPosition === 'right' ? 'vertical' : 'horizontal'}
                      align={legendPosition === 'right' ? 'right' : 'center'}
                      verticalAlign={legendPosition === 'right' ? 'middle' : 'bottom'}
                      wrapperStyle={{
                        top: legendPosition === 'right' && '50%',
                        transform: legendPosition === 'right' && 'translateY(-50%)',
                        height: legendPosition === 'right' && 'auto',
                        bottom: legendPosition === 'right' && 'auto'
                      }}
                    />
                  </PieChart>
                </ResponsiveContainer>
              }

              {!chartData?.every(item => item.value === 0) && caption && <div className='viso-chart-card__caption viso-chart-card__caption--doughnut'>{caption}</div>}
            </div>
          </div>
        </div>
      }
    >
      <IncidentChartMenu onExplain={() => onExplain({ data: chartData, chartType: 'pie' })} />
    </Card>
  )
}

export default IncidentPieChart